import React from 'react';
import BlogArticle from 'views/BlogArticle';

const BlogArticlePage = () => {
  return <BlogArticle />;
};

export default BlogArticlePage;
